module.exports = __webpack_public_path__ + "static/assets/3d3dd8d0057b638cbdbf4c622fe8cef0.png";